// assets/bb-home-hero.js
// Banner inteiro clicável (hero-banner-vzk). O link/botão interno continua funcionando e o
// clique é ignorado quando veio de um arrasto do Swiper. A instância vem de el.swiper, que
// é parte do contrato de assets/bb-swiper.js (o Swiper 11 a grava no elemento ao montar).
//
// Ouvintes delegados no document e registrados uma vez só: a home tem duas seções de hero,
// cada uma com o seu <script src>, e cada <script src> executa este arquivo de novo. Um
// ouvinte por slide registrado a cada execução duplicaria o clique; e no editor de temas a
// seção recarregada ganha slides novos, que a delegação cobre sem precisar reexecutar.
(() => {
  if (window.bbHomeHero) return;
  window.bbHomeHero = true;

  const slideDoEvento = (event) => {
    if (event.target.closest('a, button')) return null;
    return event.target.closest('[data-hero-banner] [data-banner-link]');
  };

  const abrir = (slide) => {
    const link = slide.dataset.bannerLink;
    if (link) window.location.href = link;
  };

  document.addEventListener('click', (event) => {
    const slide = slideDoEvento(event);
    if (!slide) return;
    const swiper = slide.closest('.swiper')?.swiper;
    if (swiper && !swiper.allowClick) return;
    abrir(slide);
  });

  // O slide tem role="link" e tabindex="0": Enter e espaço abrem o link, como no original.
  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Enter' && event.key !== ' ') return;
    const slide = slideDoEvento(event);
    if (!slide) return;
    event.preventDefault();
    abrir(slide);
  });
})();
